export const ventasRoutesMap = {
  registro: {
    name: 'Registrar Venta',
    path: '/ventas/registro',
  },
  registroOffline: {
    name: 'Registrar Venta Offline',
    path: '/ventas/registro-offline',
  },
  gestion: {
    name: 'Gestión de Ventas',
    path: '/ventas/gestion',
  },
  gestionOffline: {
    name: 'Gestión de Ventas Offline',
    path: '/ventas/gestion-offline',
  },
}
